<div class="h-100 w-100 padt-5 container-scans cursor">
    <div class="vehicle-profile-header d-flex gap5">
        <div class="widget-title">{{widgetData?.title}}</div>
        <!-- <div class="widget-status">Excellent</div> -->
    </div>
    <div class="chart-container">
        <app-scatter-echart [xAxis]="scatterChartData?.xAxis" [yAxis]="scatterChartData?.yAxis" [series]="scatterChartData?.series" [grid]="scatterChartData?.grid" [toolbox]="scatterChartData?.toolbox"></app-scatter-echart>
    </div>
    <!-- <div class="no-data-text d-flex justify-content-center align-items-center">
        No Data
    </div> -->
</div>
